export default __webpack_public_path__ + "static/media/4-_Wattathon.6c17609a.mp3";